<template>
	<div class="usercp-primary">
		<div class="v-comment">
			<div class="header">
				<h3>我的评论</h3>
			</div>

			<div class="v-comment-list" v-loading="loading">
				<div v-for="item in list">
					<div class="v-comment-item">
						<div class="avatar" style="width: 30px; height: 30px">
							<img
								:src="item.avatar ? item.avatar : '/static/img/no-avatar.png'"
								:alt="item.nickname"
							/>
						</div>
						<div class="user">
							<span class="nickname">{{ item.nickname }}</span>
							<span class="countdown" v-if="item.countdown == 0">刚刚</span>
							<span class="countdown" v-else>{{ item.countdown }}前</span>
							<span class="region-text">{{ item.region }}</span>
						</div>
						<div
							class="content"
							v-html="$options.filters.atuser(item.content)"
						></div>
						<div class="toolbar">
							<span
								v-if="user && (user.is_admin != 0 || user.id == item.user_id)"
							>
								<a href @click.prevent="deleteItem(item.id)">
									<i class="fa fa-trash"></i> 删除
								</a>
							</span>
						</div>
					</div>
				</div>

				<div v-if="!list.length" class="notfound text-center">
					此内容暂无评论
				</div>

				<div v-if="total > 0">
					<el-pagination
						background
						layout="prev, pager, next"
						@current-change="getList"
						:current-page.sync="curPage"
						:page-size="parseInt(pageSize)"
						:total="total"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Comment",
	data() {
		return {
			user: undefined,
			total: 0,
			curPage: 1,
			pageSize: 20,
			list: [],
			loading: true
		};
	},
	filters: {
		atuser(val) {
			return val.replace(/(@[^\s]+\s?)/g, '<i class="atuser">$1</i> ');
		}
	},
	methods: {
		getList(page, callback) {
			this.curPage = page;
			this.loading = true;
			this.axios
				.get(this.axios.apiGateway + "comment/mypost", {
					params: {
						refType: this.refType,
						pagesize: this.pageSize,
						uid: this.user ? this.user.id : 0,
						page: page
					}
				})
				.then(res => {
					this.total = parseInt(res.data.total);
					this.list = res.data.list;
					this.loading = false;
					if (callback) {
						callback(res);
					}
				});
		},
		deleteItem(id) {
			this.$message.closeAll();
			this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.axios
						.get(this.axios.apiGateway + "comment/delete", {
							params: {
								id: id,
								token: this.user.token
							}
						})
						.then(res => {
							if (res.data.errcode) {
								this.$message.error(res.data.errmsg);
							} else {
								this.getList(0, res => {
									this.$message.success("评论删除成功！");
								});
							}
						});
				})
				.catch(() => {
					this.$message.info("已取消删除");
				});
		}
	},
	created() {
		this.$store.dispatch("notify", user => {
			this.user = user;
		});

		this.user = this.$store.getters.user;
		this.getList();
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Usercp/Comment.vue